import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import { deleteSpecialOccassions, getCategorys, getSpecialOccassions, getProfitCenter, insertSpecialOccassions, getDepartments, } from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import Select from "react-select";
import { format } from 'date-fns';

import FilterComponent from "../pages/FilterComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getSecureItem } from "../../services/SecureStorage";

export default function SpecialOccassion() {
  const UID = getSecureItem("userId");
  const [addSpecialOccassionModal, setAddSpecialOccassionModal] = useState(false);
  const [editSpecialOccassionModal, setEditSpecialOccassionModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const [SpecialOccassions, setSpecialOccassions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataFilter, setDataFilter] = useState([]);
  const [category, setCategory] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [typesofSpecialOccassions, setTypesofSpecialOccassions] = useState([]);
  const [deleteSpecialOccationTypeId, setDeleteSpecialOccationTypeId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const [department,setDepartment]=useState([])
 const [specialOccassionData, setSpecialOccassionData] = useState({
  Id: "",
  departmentId: "",
  UserId: UID,
  Dates: null,
  Year: new Date().getFullYear(),
  AllowableSpecialOccassions: [],
  department: "",
});
useEffect(() => {
  console.log("specialOccassionData",specialOccassionData);
  
}, [specialOccassionData])

  const openAddSpecialOccassionModal = () => {
    setSpecialOccassionData({
      Id: "",
      departmentId: "",
      UserId: UID,
      Dates: [],
      Year: "",
      AllowableSpecialOccassions: [],
      department: "",
    });
    setAddSpecialOccassionModal(!addSpecialOccassionModal);
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      position: 'absolute',
      bottom: '100%',  // Position menu above the select input
      top: 'auto',    // Remove default top positioning
      marginBottom: '5px', // Add some space between input and menu
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px', // Adjust this value as needed
    })
  };

  // ___________________________________________________________________________________________________
  //  days checkbox function
  // _________________________________________________________________________________________________________
  const handleCheckboxChange = (e, day) => {
    const { checked } = e.target;

    setSpecialOccassionData((prevData) => {
      const selectedDays = Array.isArray(prevData?.AllowableSpecialOccassions)
        ? prevData.AllowableSpecialOccassions
        : [];

      const updatedDays = checked
        ? [...selectedDays, day] // Add day if checked
        : selectedDays.filter((selectedDay) => selectedDay !== day); // Remove day if unchecked

      return {
        ...prevData,
        AllowableSpecialOccassions: updatedDays,
      };
    });
  };

  // _____________________________________________________________________________________________
  // __________________________________________________________________________________________
  const fetchSpecialOccassions = async () => {
    setLoading(true);
    try {
      const data = await getSpecialOccassions(UID);
      console.log(data.data.data, "Fetched data");
      setSpecialOccassions(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching SpecialOccassions", error);
    }
    setLoading(false);
  };

  const openEditSpecialOccassionModal = (data) => {
    if (!data) {
      console.error("No data provided to open the modal.");
      return; // Exit early if data is not valid
    }
  
    console.log("Original Data", data);
  
    // Transform AllowableSpecialOccassions
    const transformedSpecialOccassions = Array.isArray(data.AllowableSpecialOccassions)
      ? data.AllowableSpecialOccassions
          .flatMap((item) =>
            typeof item === "string" ? item.split(",").map((day) => day.trim()) : []
          )
      : [];
  
    console.log("Transformed AllowableSpecialOccassions", transformedSpecialOccassions);
  
    // Find SpecialOccassionName (if needed)
    const SpecialOccassionName = typesofSpecialOccassions.find(
      (item) => item.Id === data?.TypeId
    );
    const specialOccassionName = SpecialOccassionName?.Name || "Unknown Occasion";
  
    // Set the state with the transformed data
    setEditSpecialOccassionModal(!editSpecialOccassionModal);
  
    setSpecialOccassionData({
      ...data,
      SpecialOccassionName: specialOccassionName,
      AllowableSpecialOccassions: transformedSpecialOccassions, // Use the transformed data
      UserId: data.UserId || "",
    });
  
    setLoading(false);
  };
  

  const handleRemoveDate = (index) => {
    const updatedDates = [...specialOccassionData.Dates];
    updatedDates.splice(index, 1); // Remove the selected date
    setSpecialOccassionData((prevData) => ({
      ...prevData,
      Dates: updatedDates,
    }));
  };

 const handleChange = (e) => {
  // If e is an array (for multi-selects)
  if (Array.isArray(e)) {
    const selectedValues = e.map((option) => option.value); // Extract values
    setSpecialOccassionData((prev) => ({
      ...prev,
      departmentId: selectedValues,
    }));
    return;
  }

  // If e is a Date object (from DatePicker)
  if (e instanceof Date) {
    const selectedDate = e;

    // Check if the date is valid
    if (!isNaN(selectedDate.getTime())) {
      const currentDates = Array.isArray(specialOccassionData.Dates)
        ? specialOccassionData.Dates
        : [];

      // Avoid duplicate dates
      const isDuplicateDate = currentDates.some(
        (existingDate) =>
          new Date(existingDate).toDateString() === selectedDate.toDateString()
      );

      if (!isDuplicateDate) {
        setSpecialOccassionData((prev) => ({
          ...prev,
          Dates: [...currentDates, selectedDate.toISOString()],
        }));
      }
    }

    return; // Exit after handling date
  }

  // Otherwise, e is a normal input event
  const { name, value } = e.target;
  setSpecialOccassionData((prev) => ({
    ...prev,
    [name]: value,
  }));
};



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check if either Days or Dates is selected
    if (
      specialOccassionData.AllowableSpecialOccassions.length === 0 &&
      (!specialOccassionData.Dates || specialOccassionData.Dates.length === 0)
    ) {
      toast.error("Please select at least one Day or Date.");
      return;
    }

    setLoading(true);

    try {
      const requests = specialOccassionData.departmentId.map((departmentId) => {
        const updatedDepData = {
          ...specialOccassionData,
          UserId: UID,
          departmentId: departmentId,
        };

        return insertSpecialOccassions(updatedDepData);
      });

      const responses = await Promise.all(requests);

      // Flag to track if all operations succeeded
      let allSuccess = true;
      let successMessage = "Special Occasion added successfully."; // Message to show if all succeed

      // Check each response and update success flag
      responses.forEach((response) => {
        if (response.data.message !== 'Special Occasion added successfully.') {
          allSuccess = false; // If any response fails, set to false
        }
      });
      // Show a single success notification if all requests succeeded
      if (allSuccess) {
        toast.success(successMessage);
      } else {
        toast.error("Some special occasions could not be added.");
      }

      // Refresh the list and open modal
      fetchSpecialOccassions();
      openAddSpecialOccassionModal();

    } catch (error) {
      console.error("Error adding SpecialOccassion:", error);
      toast.error(error?.response?.data?.error || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };


  const handleEdit = async (e) => {
    e.preventDefault();
    if (
      specialOccassionData.AllowableSpecialOccassions.length === 0 &&
      (!specialOccassionData.Dates || specialOccassionData.Dates.length === 0)
    ) {
      toast.error("Please select at least one Day or Date.");
      return;
    }
    setLoading(true);
    try {
      const response = await insertSpecialOccassions(specialOccassionData);
      if (response?.data) {
        console.log("Special Occasions edited successfully:", response);
        toast.success(
          response?.data?.message || "Special Occasion edited successfully."
        );
        setEditSpecialOccassionModal(false);
        fetchSpecialOccassions();
      } else {
        console.warn("Unexpected response:", response);
        toast.error(
          response.data?.message || "Failed to add special occasion."
        );
      }
    } catch (error) {
      console.error("Error editing Special Occasions:", error);
      toast.error(
        error?.response?.data?.error || "Failed to add special occasion."
      );
    } finally {
      // Explicitly close the modal
      setLoading(false);
    }
  };

  const handleDelete = async (SpecialOccassionId) => {
    const removeData = {
      Id: SpecialOccassionId,
      TableName: "SpecialOccations",
    };
    try {
      const res = await deleteSpecialOccassions(removeData, UID);
      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Special Occation Deleted");
          fetchSpecialOccassions(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Special Occation ");
      }
    } catch (error) {
      // Check for specific error status and handle gracefully
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Special Occation .";
        toast.error("Special Occation already using cannot delete");
      } else {
        console.error("Error removing Special Occation:", error);
        toast.error("Error deleting Special Occation . Please try again.");
      }
    }
  };

  const openModal = (SpecialOccassionId) => {
    setDeleteSpecialOccationTypeId(SpecialOccassionId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteSpecialOccationTypeId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deleteSpecialOccationTypeId) {
      handleDelete(deleteSpecialOccationTypeId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };

  const currentYear = new Date().getFullYear();
  const futureYears = 5;
  const years = [];
  for (let year = currentYear; year <= currentYear + futureYears; year++) {
    years.push(year);
  }
  // const columnsFilter = [
  //   {
  //     name: "Sl No",
  //     selector: (row, index) => index + 1,
  //     sortable: true,
  //     grow: 0,
  //     width: "80px",
  //   },

  //   {
  //     name: "Year",
  //     selector: (row) => row.Year,
  //     sortable: true,
  //   },
  //   {
  //     name: "Day",
  //     selector: (row) => row.Days,
  //     sortable: true,
  //   },

  //   {
  //     name: "Action",
  //     selector: (row) => (
  //       <div className="flex items-stretch gap-10">
  //         <button
  //           className="bg-sky rounded-[4px] px-10 py-[8px]"
  //           onClick={() => openEditSpecialOccassionModal(row)}
  //         >
  //           <IconEdit className="text-white w-[18px] h-[18px]" />
  //         </button>
  //         <button
  //           className="bg-danger rounded-[4px] px-10 py-[8px]"
  //           onClick={() => openModal(row.Id)}
  //         >
  //           <IconTrash className="text-white w-[18px] h-[18px]" />
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];
  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Year",
      selector: (row) => row.Year,
      sortable: true,
      grow: 0,
      width: "80px",
    },
    {
      name: "Dates",
      selector: (row) =>
        row.Dates?.map((date) => format(new Date(date), "yyyy-MM-dd")).join(", "),
      sortable: true,
    },
    // {
    //   name: "Day",
    //   selector: (row) => row.Days?.join(", "), // Map and join Days array
    //   sortable: true,
    // },
    {
      name: "Day",
      selector: (row) => {
        // Ensure AllowableSpecialOccassions is an array before flatMap
        const days = Array.isArray(row?.AllowableSpecialOccassions)
          ? row.AllowableSpecialOccassions.flatMap((occasion) => occasion?.split(','))
          : [];
        return days.length > 0 ? days.join(", ") : "N/A";
      },
      sortable: true,
    },
    {
      name: "Department",
      selector: (row) => {
        const DepartmentName = department.find((el) => el.Id === row.departmentId);
        return DepartmentName ? DepartmentName.Name : "N/A";
      },
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditSpecialOccassionModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];


  const filteredItems = dataFilter?.filter((item) => {
    const DepartmentName = department.find((el) => el.Id === item.departmentId)?.Name || "";
    return (
      item.Name?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Code?.toLowerCase().includes(filterText.toLowerCase()) ||
      DepartmentName.toLowerCase().includes(filterText.toLowerCase()) ||
      String(item.Year || "").toLowerCase().includes(filterText.toLowerCase())
    );
  });


  const subHeaderComponentMemo = useMemo(() => {
  }, [filterText, resetPaginationToggle]);

  const clearData = () => {
    setSpecialOccassionData({
      Id: "",
      departmentId: "",
      UserId: UID,
      Dates: [],
      Year: "",
      AllowableSpecialOccassions: [],
      department: "",
    });
  };

  const clearDataForEdit = () => {
    setSpecialOccassionData((ref) => ({
      ...ref, // Spread the previous state
      departmentId: "",
      UserId: UID,
      Dates: [],
      Year: "",
      AllowableSpecialOccassions: [],
      department: "",
    }));
  };

  // const CategoryOptions = category.map((dept) => ({
  //   value: dept.Id,
  //   label: dept.NamewithDep,
  // }));

  const DepartmentOptions=department.map((dept)=>({
    value: dept.Id,
    label: dept.Name,
  }))

  // useEffect(() => {
  //   const fetchCategory = async () => {
  //     try {
  //       const response = await getCategorys(UID);

  //       setCategory(response.data.data);
  //       console.log(category, "pro");
  //     } catch (error) {
  //       console.error("Error fetching profit centers:", error);
  //     }
  //   };

  //   fetchCategory();
  // }, []);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);

        setDepartment(response.data.data);
        console.log(department, "pro");
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchDepartment();
  }, []);


  useEffect(() => {
    fetchSpecialOccassions();
    // fetchSpecialOccassionTypes();
  }, []);

  useEffect(() => {
    if (
      SpecialOccassions &&
      SpecialOccassions.length > 0 &&
      department.length > 0
    ) {
      const updatedData = SpecialOccassions.map((item, index) => {
        // Find the category name based on CategoryId
        const matchedDepartment = department.find(
          (dep) => dep.Id === item.departmentId
        );
        const DepartmentName = matchedDepartment ? matchedDepartment.Name : ""; // Default to empty string if no match

        return {
          Slno: index + 1,
          Id: item.Id || "",
          Name: item.Name || "",
          Dates: item.Dates || "",
          Year: item.Year || "",
          departmentId: item.departmentId || "",
          DepartmentName: DepartmentName, // Adding the category name here
          TypeId: item.TypeId || "",
          AllowableSpecialOccassions: item.AllowableSpecialOccassions || "",
          UserId: UID || "",
          Days: item.AllowableSpecialOccasions,
        };
      });

      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [SpecialOccassions, department]); // Correct dependency array // Make sure to include categories in the dependency array




  const handleFilter = (filteredResults) => {
    console.log(filteredResults);
    setDataFilter(filteredResults);
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  console.log('speca', SpecialOccassions);


  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this SpecialOccassion?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Special Occassions" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Department"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddSpecialOccassionModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={SpecialOccassions} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {/* 
      =============================================Add================================== */}

      {addSpecialOccassionModal && (
        <>
          <div className="fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Special Occassion
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddSpecialOccassionModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleSubmit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px] "
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[75vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>
                        Select Year: <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        id="year"
                        name="Year"
                        value={specialOccassionData.Year}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label className="flex items-center">
                        Choose Days Or Date
                        <span style={{ color: "red", marginLeft: "4px" }}>
                          *
                        </span>
                      </label>
                    </div>
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label htmlFor="days">Days:</label>

                      <div id="days" className="grid grid-cols-4 gap-4">
                        {[
                          "Sunday",
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday",
                        ].map((day) => (
                          <label
                            key={day}
                            className="flex items-center gap-2 py-2"
                          >
                            <span className="whitespace-nowrap">{day}</span>
                            <input
                              type="checkbox"
                              name="AllowableSpecialOccassions"
                              value={day}
                              checked={specialOccassionData.AllowableSpecialOccassions.includes(
                                day
                              )}
                              onChange={(e) => handleCheckboxChange(e, day)}
                            />
                          </label>
                        ))}
                      </div>
                    </div>
                    {/* Date Array with Remove Button */}
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>Dates:</label>
                      <div className="flex flex-wrap gap-4 mb-2">
                        {specialOccassionData?.Dates?.map((date, index) => (
                          <div
                            key={index}
                            className="flex items-center gap-2 bg-gray-200 text-gray-800 px-4 py-2 rounded"
                          >
                            <span>{new Date(date).toLocaleDateString()}</span>
                            <button
                              onClick={() => handleRemoveDate(index)}
                              className="text-red-500 hover:text-red-700"
                            >
                              ✖
                            </button>
                          </div>
                        ))}
                      </div>
                     <DatePicker
  selected={null} // Or you can bind to the last selected date
  onChange={handleChange}
  placeholderText="Select a date"
  className=""
  dateFormat="yyyy-MM-dd"
/>

                    </div>

                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>
                        Department <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        isMulti
                        name="departmentId"
                        value={DepartmentOptions?.filter((option) =>
                          specialOccassionData.departmentId?.includes(option.value)
                        )}
                        onChange={(selectedOptions) => handleChange(selectedOptions)}
                        options={DepartmentOptions}
                        styles={customStyles}
                        menuPlacement="auto"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openAddSpecialOccassionModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* 
      ================================================edit================================== */}

      {editSpecialOccassionModal && (
        <>
          {/* Modal Wrapper */}
          <div className="fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              {/* Modal Header */}
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit SpecialOccassion
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditSpecialOccassionModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleEdit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px] "
              >
                {/* Modal Body */}
                <div className="my-10 md:px-10 px-[7px] max-h-[75vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    {/* Year Selector */}
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label htmlFor="year">
                        Select Year: <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        id="year"
                        name="Year"
                        value={specialOccassionData.Year}
                        onChange={handleChange}
                      >
                        <option>{specialOccassionData.Year}</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Allowable Days Checkboxes */}
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label className="flex items-center">
                        Choose Days Or Date
                        <span style={{ color: "red", marginLeft: "4px" }}>
                          *
                        </span>
                      </label>
                    </div>
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label htmlFor="days">Days:</label>

                      <div id="days" className="grid grid-cols-4 gap-4">
                        {[
                          "Sunday",
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday",
                        ].map((day) => (
                          <label
                            key={day}
                            className="flex items-center gap-2 py-2"
                          >
                            <span className="whitespace-nowrap">{day}</span>
                            <input
                              type="checkbox"
                              name="AllowableSpecialOccassions"
                              value={day}
                              checked={specialOccassionData.AllowableSpecialOccassions.includes(
                                day
                              )}
                              onChange={(e) => handleCheckboxChange(e, day)}
                            />
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Date Array with Remove Button */}
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>Dates:</label>
                      <div className="flex flex-wrap gap-4 mb-2">
                        {specialOccassionData?.Dates?.map((date, index) => (
                          <div
                            key={index}
                            className="flex items-center gap-2 bg-gray-200 text-gray-800 px-4 py-2 rounded"
                          >
                            <span>{new Date(date).toLocaleDateString()}</span>
                            <button
                              onClick={() => handleRemoveDate(index)}
                              className="text-red-500 hover:text-red-700"
                            >
                              ✖
                            </button>
                          </div>
                        ))}
                      </div>

                      <DatePicker
  selected={null} // Or you can bind to the last selected date
  onChange={handleChange}
  placeholderText="Select a date"
  className=""
  dateFormat="yyyy-MM-dd"
/>
                    </div>

                    {/* Category Selector */}
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>
                        Department:<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="departmentId"
                        value={specialOccassionData.departmentId}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select department
                        </option>
                        {department.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div>


                  </div>
                </div>

                {/* Modal Footer */}
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Edit"}
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Backdrop */}
          <div
            // onClick={openEditSpecialOccassionModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
